export default __webpack_public_path__ + "static/media/moonbeam.f27bc87e.png";